import * as React from 'react';

export const CascadingContext = React.createContext({
    parentPopupState: null,
    rootPopupState: null,
});

export default {};
